export default __webpack_public_path__ + "static/B0274-8b0846511a2683d22a92d2bbbe99dd18.png";